import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Button, Link, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link as RouterLink } from 'react-router-dom';

const PINNED_FOOTER_HEIGHT = 'calc(152px + env(safe-area-inset-bottom, 0px))';

function LegalFooterLinks() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      <Link component={RouterLink} to="/m/kayttoehdot" underline="hover" sx={{ mx: 0.5 }}>
        Käyttöehdot
      </Link>
      ·
      <Link
        component={RouterLink}
        to="/m/tietosuojaseloste"
        underline="hover"
        sx={{ mx: 0.5 }}
      >
        Tietosuoja
      </Link>
      ·
      <Link component={RouterLink} to="/m/faq" underline="hover" sx={{ mx: 0.5 }}>
        UKK
      </Link>
    </Typography>
  );
}

export default function MobileLegalFrame({
  title,
  children,
  actions = null,
  onBack = null,
  backLabel = 'Takaisin',
  scrollRef = null,
}) {
  const pinnedFooter = Boolean(actions);

  if (pinnedFooter) {
    return (
      <>
        <Helmet>
          <title>{title} | Rahoituskanava</title>
        </Helmet>
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            px: 2,
            pt: 2,
          }}
        >
          <Box sx={{ flexShrink: 0, pb: 1.5 }}>
            {onBack && (
              <Button
                onClick={onBack}
                startIcon={<ArrowBackIcon />}
                sx={{
                  mb: 1,
                  ml: -1,
                  minHeight: 40,
                  textTransform: 'none',
                  color: 'text.secondary',
                }}
              >
                {backLabel}
              </Button>
            )}
            <Typography variant="h1">{title}</Typography>
          </Box>

          <Box
            ref={scrollRef}
            sx={{
              flex: 1,
              minHeight: 0,
              overflowY: 'auto',
              WebkitOverflowScrolling: 'touch',
              pb: PINNED_FOOTER_HEIGHT,
              '& .MuiTypography-root': { mb: 2 },
              '& a': { color: 'secondary.main' },
            }}
          >
            {children}
          </Box>
        </Box>

        <Box
          sx={{
            position: 'fixed',
            left: 0,
            right: 0,
            bottom: 0,
            px: 2,
            pt: 2,
            pb: 'max(16px, env(safe-area-inset-bottom))',
            bgcolor: 'background.default',
            borderTop: 1,
            borderColor: 'divider',
            zIndex: 20,
          }}
        >
          {actions}
        </Box>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{title} | Rahoituskanava</title>
      </Helmet>
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          px: 2,
          py: 3,
        }}
      >
        {onBack && (
          <Button
            onClick={onBack}
            startIcon={<ArrowBackIcon />}
            sx={{
              mb: 1,
              ml: -1,
              minHeight: 40,
              textTransform: 'none',
              color: 'text.secondary',
            }}
          >
            {backLabel}
          </Button>
        )}
        <Typography variant="h1" gutterBottom>
          {title}
        </Typography>
        <Box
          sx={{
            '& .MuiTypography-root': { mb: 2 },
            '& a': { color: 'secondary.main' },
          }}
        >
          {children}
        </Box>
        <Box sx={{ mt: 4, pt: 2, borderTop: 1, borderColor: 'divider' }}>
          <LegalFooterLinks />
        </Box>
      </Box>
    </>
  );
}
